import { render, staticRenderFns } from "./GsPieChart.vue?vue&type=template&id=6543cfb6&"
import script from "./GsPieChart.vue?vue&type=script&lang=js&"
export * from "./GsPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports